var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "windows" },
      [
        _c(
          "a-row",
          { attrs: { gutter: 16 } },
          [
            _c("a-col", { staticClass: "gutter-row", attrs: { span: 5 } }, [
              _c(
                "div",
                { staticClass: "list" },
                [
                  _vm.list.length === 1
                    ? _c("div", { staticClass: "list-item" }, [
                        _c(
                          "h2",
                          {
                            on: {
                              click: function($event) {
                                return _vm.handleClickJump(
                                  _vm.list[0].link,
                                  _vm.list[0].openType
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.list[0].name))]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.list[0].info) }
                        })
                      ])
                    : [
                        _c(
                          "div",
                          { staticClass: "slide-wrap" },
                          _vm._l(_vm.list, function(item, index) {
                            return _c("div", { key: "drop_" + index }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "sensors",
                                      rawName: "v-sensors",
                                      value: {
                                        type: "BrandServeView",
                                        event: "click",
                                        getParams: function() {
                                          return _vm.brandServeView(item)
                                        }
                                      },
                                      expression:
                                        "{\n                    type: 'BrandServeView',\n                    event: 'click',\n                    getParams: () => brandServeView(item),\n                  }"
                                    }
                                  ],
                                  staticClass: "slide-wrap-item",
                                  class: {
                                    "slide-wrap-item-active":
                                      _vm.activeKey === index
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleSlideChange(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br")
                            ])
                          }),
                          0
                        )
                      ]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("a-col", { staticClass: "gutter-row", attrs: { span: 19 } }, [
              _c("div", { staticClass: "content" }, [
                _c("div", { ref: "content", staticClass: "content-list-out" }, [
                  _c(
                    "div",
                    { staticClass: "content-list-kby" },
                    _vm._l(_vm.serviceList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: "p_" + index,
                          staticClass: "content-list-kby-item"
                        },
                        [
                          _c("h5", [_vm._v(_vm._s(item.name))]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "bd" },
                            _vm._l(item.items, function(i, idx) {
                              return _c(
                                "a",
                                {
                                  key: "drop_link_" + idx,
                                  attrs: {
                                    title:
                                      i.productInfoClientVo.productName ||
                                      i.platformName
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickLink(i)
                                    }
                                  }
                                },
                                [
                                  i.country
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/countryFlag/" +
                                            i.country +
                                            ".svg"),
                                          alt: ""
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      style: {
                                        width:
                                          _vm.NODE_PLA === "kby"
                                            ? "128px"
                                            : "140px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          i.productInfoClientVo.productName ||
                                            i.platformName
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "recommend-wrap" }, [
                  _c("div", { staticClass: "recommend" }, [
                    _c("h2", [_vm._v("活动推荐")]),
                    _vm._v(" "),
                    _vm.recommendList.length
                      ? _c(
                          "div",
                          { staticClass: "active-wrap" },
                          [
                            _vm._l(_vm.recommendList, function(com, index) {
                              return [
                                com.url
                                  ? _c(
                                      "a",
                                      {
                                        key: "a_" + index,
                                        staticClass: "active",
                                        attrs: {
                                          href: com.url,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: com.picPath,
                                            alt: com.name
                                          }
                                        })
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        key: "div_" + index,
                                        staticClass: "active"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: com.picPath,
                                            alt: com.name
                                          }
                                        })
                                      ]
                                    )
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-153c8438", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153c8438","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AlertWindow.vue
// module id = null
// module chunks = 